import { getItems } from "../../../api/repositories/courses";

export default {
  async getCoursesByUser({ commit }, { _id }) {
    try {

      commit("SET_LOADING", true);

      const data = await getItems(_id);
      
      commit("SET_COURSE", data);

      commit("SET_LOADING", false);
    } catch (error) {
      commit("CATCH_ERROR", error);
    }
  },

  changeDays({ commit, state }, { _days }){

    const data = {
      ...state.course,
      days: _days
    }
    commit("SET_COURSE", data);

  }
  
};
